/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { useEffect, ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

const GA = ({ children }: { children: ReactElement }): ReactElement => {
	const location = useLocation();

	useEffect(() => {
		window.gtag('set', 'page_path', location.pathname);
		window.gtag('event', 'page_view', {
			page_location: `${window.location.protocol}//${window.location.host}${location.pathname}`,
		});
	}, [location.pathname]);

	return children;
};

export default GA;
